import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-template",
  "use": "icon-template-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-template\">\r\n<path d=\"M854.1 169.3H169.2v237.5h684.9V169.3z m-46 191.5H215.2V215.3h592.9v145.5zM169.2 637.6h326.5V463.9H169.2v173.7z m46-127.7h234.5v81.7H215.2v-81.7zM169.2 854.7h326.5V681H169.2v173.7z m46-127.7h234.5v81.7H215.2V727zM553.3 463.9v390.7h301.4V463.9H553.3z m255.5 344.7H599.3V509.9h209.4v298.7z\" p-id=\"16543\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol